import { useEffect, useState } from "react";
import { api, errMsg, itDate } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Umbrella } from "@phosphor-icons/react";

/** Situazione ferie di un dipendente: ultima ferie, storico periodi e giorni goduti nell'anno. */
export const VacationDialog = ({ employeeId, name, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/employees/${employeeId}/ferie`)
      .then((r) => setData(r.data))
      .catch((e) => toast.error(errMsg(e)))
      .finally(() => setLoading(false));
  }, [employeeId]);

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="rounded-sm sm:max-w-lg max-h-[88vh] overflow-y-auto"
        data-testid="vacation-dialog">
        <DialogHeader>
          <DialogTitle className="font-head flex items-center gap-2">
            <Umbrella size={18} /> Ferie — {data?.employee?.name || name}
          </DialogTitle>
        </DialogHeader>

        {loading && <p className="text-sm text-muted-foreground py-6 text-center">Caricamento...</p>}

        {!loading && data && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-2">
              <div className="rounded-sm border border-border p-3">
                <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                  Giorni goduti {data.year}
                </div>
                <div className="text-2xl font-bold tabular-nums" data-testid="vacation-days-year">
                  {data.days_taken_year}
                </div>
              </div>
              <div className="rounded-sm border border-border p-3">
                <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                  Ultima ferie effettuata
                </div>
                <div className="text-sm font-semibold tabular-nums mt-1" data-testid="vacation-last">
                  {data.last_vacation
                    ? `${itDate(data.last_vacation.date_from)} → ${itDate(data.last_vacation.date_to)}`
                    : "Nessuna"}
                </div>
              </div>
            </div>

            <div>
              <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mb-1">
                Storico ferie ({data.periods.length} periodi · {data.days_total} giorni totali)
              </div>
              <div className="rounded-sm border border-border overflow-hidden">
                <table className="w-full text-sm bc-no-cards" data-testid="vacation-table">
                  <thead className="bg-secondary">
                    <tr>{["Dal", "Al", "Giorni"].map((h) => (
                      <th key={h} className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{h}</th>
                    ))}</tr>
                  </thead>
                  <tbody>
                    {data.periods.length === 0 && (
                      <tr><td colSpan={3} className="px-3 py-6 text-center text-muted-foreground"
                        data-testid="vacation-empty">Nessuna ferie registrata</td></tr>
                    )}
                    {data.periods.map((p) => (
                      <tr key={p.date_from} className="border-t border-border"
                        data-testid={`vacation-row-${p.date_from}`}>
                        <td className="px-3 py-1.5 tabular-nums">{itDate(p.date_from)}</td>
                        <td className="px-3 py-1.5 tabular-nums">{itDate(p.date_to)}</td>
                        <td className="px-3 py-1.5 tabular-nums font-semibold">{p.days}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
